import {info as infoNotification} from 'react-notification-system-redux';
import {getNotificationOptions} from "../ducks/basket";

export default function initFullCartView(messages, store) {
    if (messages.length) {
        messages.forEach((message) => {
            store.dispatch(infoNotification(getNotificationOptions(null, message)));
        });
    }
}



// WEBPACK FOOTER //
// ./src/widgets/DjangoMessages.js